<template>
    <static-layout title="Terms and conditions">
        <div v-for="(section, key) in sections" :key="key" class="static-content">
            <div v-html="section.content"></div>
        </div>
    </static-layout>
</template>

<script>
import PageSection from "@/models/PageSection";
import StaticLayout from "@/layouts/StaticLayout";
import Settings from "../../models/Settings";

export default {
    name: "Terms",
    components: {StaticLayout},
    data: function () {
        return {
            sections: [],
            netFee: 30,
            remainingPercent: 70,
        }
    },
    methods: {
        fetchSetting() {
            Settings
                .where('key', 'noodzly_fee')
                .first()
                .then(setting => {
                    this.netFee = setting?.value || 30;
                    this.remainingPercent = 100 - this.netFee;
                    this.fetchPageSections();
                })
                .catch((e) => console.log(e))
        },
        fetchPageSections() {
            PageSection
                .where('page', 'terms')
                .get()
                .then(sections => {
                this.sections = sections.map(section => {
                    let updatedContent = section.content;
                    updatedContent = updatedContent
                        .replace(/{{netFee}}/g, this.netFee + '%')
                        .replace(/{{remainingPercent}}/g, this.remainingPercent + '%');

                    return {
                        ...section,
                        content: updatedContent
                    };
                });
            }).catch((e) => console.log(e))
        },
    },
    created() {
        this.fetchSetting();
        // this.fetchPageSections();
    }
}
</script>

<style scoped module lang="scss">

</style>
